import { CommonModule } from '@angular/common';
import { Component, HostListener, Inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { NavigationStart, Router, RouterEvent } from '@angular/router';

type TiposValues = 'IMOVEIS_UFN' | 'IMOVEIS_CALCADAO' | 'IMOVEIS_UFSM' | 'IMOVEIS_AREA_MILITAR' | 'IMOVEIS_BASE_AEREA' | 'IMOVEIS_BRIGADA_HOSPITAL' | 'IMOVEIS_COLEGIO_MILTAR' | 'IMOVEIS_AREA_VERDE_QUARTEIS';

@Component({
   selector: 'app-modal-opcao-contrato',
   standalone: true,
   imports: [CommonModule, MatDialogModule, MatIcon, MatButton],
   templateUrl: './modal-opcao-contrato.component.html',
   styleUrl: './modal-opcao-contrato.component.scss'
})
export class ModalOpcaoContratoComponent {
   title: string = 'Escolha uma opção';
   tipo: TiposValues;

   private popStateListener = () => this.fecharModal(true);

   constructor(
      public router: Router,
      public dialogRef: MatDialogRef<ModalOpcaoContratoComponent>,
      @Inject(MAT_DIALOG_DATA) public data: { tipo: TiposValues }
   ) {
      this.tipo = data.tipo;
      this.handleTitle();

      // Adiciona uma entrada no histórico ao abrir o diálogo
      history.pushState(null, '', location.href);

      // Escuta o botão de voltar do navegador
      window.addEventListener('popstate', this.popStateListener);

      // Remove o listener se o usuário fechar o modal manualmente
      this.dialogRef.afterClosed().subscribe(() => {
         window.removeEventListener('popstate', this.popStateListener);

         // Volta um passo no histórico (só se ainda não voltou)
         if (history.state === null) history.back();
      });
   }

   handleTitle() {
      const titleMap: Record<string, string> = {
         IMOVEIS_UFN: 'Próximos à UFN',
         IMOVEIS_CALCADAO: 'Próximos ao Calçadão',
         IMOVEIS_UFSM: 'Próximos à UFSM',
         IMOVEIS_AREA_MILITAR: 'Próximos à Área Militar',
         IMOVEIS_BASE_AEREA: 'Próximos à Base Aérea',
         IMOVEIS_BRIGADA_HOSPITAL: 'Próximos à 6a Brigada e Hospital Militar',
         IMOVEIS_COLEGIO_MILTAR: 'Próximos ao Colégio Militar',
         IMOVEIS_AREA_VERDE_QUARTEIS: 'Próximos à Área verde dos Quartéis',
         IMOVEIS_CAMOBI: 'Bairro Camobi',
         IMOVEIS_CENTRO: 'Bairro Centro',
         IMOVEIS_NS_MEDIANEIRA: 'Nossa Senhora Medianeira',
         IMOVEIS_NS_LOURDES: 'Nossa Senhora de Lourdes',
         IMOVEIS_NS_DORES: 'Nossa Senhora das Dores'
      };

      this.title = titleMap[this.tipo] || '';
   }

   fecharModal(triggeredByBackButton = false) {
      // Fecha o modal e deixa o popstate limpar o histórico
      this.dialogRef.close();
   }

   selectMilitar(base: TiposValues) {
      this.tipo = base;
      this.handleTitle();
   }

   clickNavegar(contrato: 'Locação' | 'Compra') {
      const sortby = 'd_date';
      const map: Record<string, any> = {
         IMOVEIS_UFN: { contrato, tags: 'Próximo UFN', sortby },
         IMOVEIS_CALCADAO: { contrato, tags: 'Próximo Calçadão', sortby },
         IMOVEIS_UFSM: { contrato, tags: 'Próximo UFSM', sortby },
         IMOVEIS_BASE_AEREA: { contrato, tags: 'Base Aérea', sortby },
         IMOVEIS_BRIGADA_HOSPITAL: { contrato, tags: '6a Brigada e Hospital Militar', sortby },
         IMOVEIS_COLEGIO_MILTAR: { contrato, tags: 'Colégio Militar', sortby },
         IMOVEIS_AREA_VERDE_QUARTEIS: { contrato, tags: 'Área verde dos Quartéis', sortby },
         IMOVEIS_CAMOBI: {contrato, cidade: 'Santa Maria', bairros: ['Camobi'], sortby},
         IMOVEIS_CENTRO: {contrato, cidade: 'Santa Maria', bairros: ['Centro'], sortby},
         IMOVEIS_NS_MEDIANEIRA: {contrato, cidade: 'Santa Maria', bairros: ['Nossa Senhora Medianeira'], sortby},
         IMOVEIS_NS_LOURDES: {contrato, cidade: 'Santa Maria', bairros: ['Nossa Senhora de Lourdes'], sortby},
         IMOVEIS_NS_DORES: {contrato, cidade: 'Santa Maria', bairros: ['Nossa Senhora das Dores'], sortby}

      };

      this.navegarParaBuscaAvancada(map[this.tipo]);
   }

   navegarParaBuscaAvancada(queryParams: any) {
      this.router.navigate(['/busca-avancada'], {
         queryParams
      });
      this.fecharModal();
   }
}
